module.exports = __webpack_public_path__ + "static/02-RUS-HEERING.beead46d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/foods/02-RUS-HEERING.png
// module id = 643
// module chunks = 35783957827783